import {Swiper, Autoplay, EffectFade, Navigation, Pagination} from 'swiper'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import {loadElementLazyImage} from "../helpers/lazy-load";
import {breakpointUp} from "../utils/breakpoints";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

let textInAnimationC = $('.js-animate-in-text')
let splitTextWords = new SplitText( textInAnimationC, {type: 'words'})
textInAnimationC.css('opacity', 1)




// arrow down
gsap.to(".js-scroll-down", {
  scrollTrigger: { start: 50 }, // start the animation when ".box" enters the viewport (once)
  opacity: 0
});

// Slider
$('.js-hero-slider').each(function (i, el){
  loadElementLazyImage($(this).find('.lazy'))
  let swiper = new Swiper(el, {
    modules: [Autoplay, EffectFade, Navigation, Pagination],
    autoplay: {
      delay: 5000,
    },
    speed: 600,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
  })
})



// Horizontal scroll
if (breakpointUp('xl')) {
  let sections = gsap.utils.toArray(".js-horizontal-scroll .js-phone-slider .swiper-slide");
  let texts = $('.js-hero-slide-text-c')

  setTimeout(function (){
    $(texts[0]).addClass('show')
  }, 400)

  let horizontalScroll = gsap.to('.js-horizontal-scroll', {
    xPercent: -50 * (sections.length - 1),
    ease: "none",
    scrollTrigger: {
      trigger: ".js-horizontal-scroll",
      pin: true,
      scrub: 1,
      //snap: 1 / (sections.length - 1),
      end: "+=" + (sections.length - 1) * 300,
      onUpdate: self => {
        texts.each(function (i, el){
          let elProcPos = 1 / (texts.length - i) - ( 1 / texts.length / 2.5)
          if (elProcPos <= self.progress) $(this).addClass('show')
        })

      }
    }
  });

  // $('.js-hero-slide-text-c').each(function(){
  //   gsap.to(this, {
  //     opacity: 1,
  //     top: 0,
  //     duration: 0.6,
  //     delay: 0.4,
  //     ease: "linear",
  //     scrollTrigger: {
  //       trigger: this,
  //       containerAnimation: horizontalScroll,
  //       start: "left right",
  //     }
  //   });
  // })


}


// Show images on button hover
if (breakpointUp('xl')) {
  $('.js-show-images-on-hover').each(function () {
    let hoverC = $(this).closest('.swiper-slide')
    $(this).hover(function () {
        hoverC.find('.js-hover-img-1').stop().fadeIn()
        hoverC.find('.js-hover-img-2').stop().delay(100).fadeIn()
        gsap.to(hoverC.find('.js-product-img'), {scale: 1.05})

      }, function () {
        hoverC.find('.js-hover-img-1').stop().fadeOut()
        hoverC.find('.js-hover-img-2').stop().fadeOut()
        gsap.to(hoverC.find('.js-product-img'), {scale: 1})
      }
    );
  })
}


gsap.set('.js-scroll-down circle', {drawSVG:'0%', transformOrigin:"50% 50%"});
export function heroAnimationsAfterLoader(){
  // window.addEventListener('load', (event) => {
    gsap.to($('.js-hero-slider'), { scale: 1, duration: 2 })
    //gsap.to($('header'), { top: 0, duration: 1 })
    //playLottie($('.js-hero-block .js-load-lottie'))

    let tl = gsap.timeline()
    tl.to( splitTextWords.words, { opacity: 1, stagger: 0.07, duration: 0.14, ease: 'none'})
    tl.to( splitTextWords.words, { top: 0, stagger: 0.07, duration: 0.5, ease: 'power2'}, '<')

    // fade in bottle images
    gsap.to('.js-hero-bottle-c', {opacity: 1, duration: 0.4, delay: 0.2})

    // arrow circle
    gsap.fromTo('.js-scroll-down circle', {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', duration: 1})



  //})
}
